import { render } from "./TopLeftGates.vue?vue&type=template&id=3ed024c8"
import script from "./TopLeftGates.vue?vue&type=script&lang=js"
export * from "./TopLeftGates.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/sportkit-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__